//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import './FormAtributoFichaTecnica.css';
import atributosFichaTecContext from '../../context/atributosFichaTecContext/atributosFichaTecContex';

/*
    Componente encargado de mostrar el formulario de Documento.
    Donde data es el atributo recibido a modificar, con el cual se modelara atributo.
    minimizar es la función encargada de ocultar el Form.
    generar es la función del context que guarda el usuario.
    titulo es la que determina que texto mostrar en encabezado del dialogo.
    atributo es el estado que maneja la informacion a actualizar, añadir o eliminar.
*/
function FormAtributoFichaTecnica({data,setData, minimizar, nuevoEditado, formDato, handleChangeAtributos, index, generar = () => console.log("Generando"), listaUsuarios = [] }) {

    const {agregarAtributoFichaTec, modificarAtributoFichaTec, eliminarAtributoFichaTec} = useContext(atributosFichaTecContext)

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [atributo, setAtributo] = useState({codAtributo:"",name: ''});
    
    //Constante que define el titulo que corresponde si vienen datos por parametros
    //const titulo = (data?.id === "" || data?.id ===  undefined) ? 'Agregar' : 'Modificar';
    const [titulo, setTitulo] = useState(nuevoEditado);

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (atributo.codAtributo === '' || atributo.codAtributo === undefined) return newErrors.codigo = 'El código de atributo debe ser colocado'
        if (atributo.name === '' || atributo.codAtributo === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {
        const errorAxi = validacion();
        if ( errorAxi === "" ) {
            try {
                const dato = atributo;
                const res = await agregarAtributoFichaTec(dato);
                if (res.codAtributo !== undefined) {
                    Swal.fire({
                        title: `Se guardo un nuevo atributo`,
                        icon: 'success',
                        text: `Código: ${res.codAtributo} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    minimizar();
                } else if(res.code == 'DUPLICATEKEY') {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del atributo",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        console.log("handlerModificar");
        

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: atributo.id,
                    codAtributo: atributo.codAtributo,
                    name: atributo.name,
                    fecMod: atributo.fecMod,
                    fecAlt: atributo.fecAlt
                }
                console.log("dato en handlerModificar 96 FormAtributoFichaTecnica");
                console.log(dato);
                
                const res = await modificarAtributoFichaTec(dato);
                if(res.codAtributo != undefined){
                    Swal.fire({
                        title: `Se modificó el atributo`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codAtributo}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    //Modela el dato para que siga el formato de los seleccionados por primera vez y para que se pueda modificar sin seleccionarlo nuevamente.
                    let datoModelado = {id:res._id,label:res.name,value:res.codAtributo,fecMod:res.fecMod,fecAlt:res.fecAlt};
                    await setData(datoModelado);
                    handleChangeAtributos({},index,'atributo',datoModelado);
                    minimizar();
                }
                else if(res.response.data.message != undefined){
                    if(res.response.data.message == 'El registro ha sido modificado desde otra sesión. Los cambios NO se guardarán'){
                        Swal.fire({
                            title:  "Se modificó el atributo desde otra sesion, actualice pestaña e intentelo nuevamente.",
                            icon: 'warning',
                            showConfirmButton: true,
                            allowEnterKey: true
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este atributo?`,
            icon: 'warning',
            text: `Se eliminará permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true
        }).then(async (result) => {
            if (result.isConfirmed){ // El usuario hizo clic en "Aceptar"
                const id = atributo.id
                const resp = await eliminarAtributoFichaTec(id);

                if(resp){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El atributo fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    
                    handleChangeAtributos({},index,'atributo',{value:'',label:''});
                } 

                minimizar(null);
            } else if (result.isDismissed) {
                // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            //Se crea codigoTarea ya que habia diferencias en el nombre de la propiedad cuando llegaba desde editarProcedimiento que cuando se agregaba una atributo nueva y se editaba.
            let docModelado = {id:data?.id, codAtributo: data.value, name: data?.label, fecMod:data?.fecMod, fecAlt:data?.fecAlt};
            setAtributo(docModelado);
        }
    },[data]);

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} atributo
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de atributo: </div>
                <input disabled={ titulo === "Modificar"} value={atributo.codAtributo} className='label-form-group-data' onChange={data => setAtributo({ ...atributo, ['codAtributo']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={atributo.name} className='label-form-group-data' onChange={data => setAtributo({ ...atributo, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormAtributoFichaTecnica;